import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BankAccountTransactionExporter  {
    _originalTypeClassName = "zERP.BO.BankAccountTransactionExporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BankAccountTransactionExporter.translate = translateService;
}
this.BankAccountTransactionExporterKey = null;
this._key = this.BankAccountTransactionExporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _BankAccountTransactionExporterKey:any;
get BankAccountTransactionExporterKey(): any {
    return this._BankAccountTransactionExporterKey;
  }
set BankAccountTransactionExporterKey(value: any) {
    this._BankAccountTransactionExporterKey = value;
    this._key = value;
  }

static ResolveCollectionItem(collectionName: any,varName: any,item: any): any{switch ((collectionName)) {case "TRANSACTIONS":
{
let transaction = Joove.Common.cast(item, "Domain.BankAccountTransactionExport");switch ((varName)) {case "DATE":
{
return CLMS.Framework.DateTime.ToString(transaction?.Date, "dd/MM/yyyy");}
case "REFERENCE":
{
return transaction?.Reference;}
case "DESCRIPTION":
{
return transaction?.Description;}
case "DEPOSIT":
{
return transaction?.Deposit;}
case "WITHDRAW":
{
return transaction?.Withdraw;}
case "PROGRESSIVE_DEPOSIT":
{
return transaction?.ProgressiveDeposit;}
case "PROGRESSIVE_WITHDRAW":
{
return transaction?.ProgressiveWithdraw;}
case "REMAINING":
{
return transaction?.Remaining;}
default:
{
return "";}
}break;
}
default:
{
return "";}
}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BankAccountTransactionExporterKey == null || $this.BankAccountTransactionExporterKey == 0;
            }


}